'use client';

import { useLanguage } from '@/context/LanguageContext';
import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

export default function TermeniConditiiPageClient() {
  const { language } = useLanguage();

  const content = {
    ro: {
      title: 'Termeni și Condiții',
      lastUpdated: 'Ultima actualizare: 30 Ianuarie 2026',
      backHome: 'Înapoi la pagina principală',
      sections: [
        {
          title: '1. Informații Generale',
          content: `Bine ați venit pe Buchetul Simonei! Prin accesarea și utilizarea acestui site web, acceptați să respectați acești Termeni și Condiții. Vă rugăm să îi citiți cu atenție înainte de a utiliza serviciile noastre.

Buchetul Simonei este un magazin online specializat în vânzarea de flori proaspete, buchete și aranjamente florale pentru diverse evenimente și ocazii speciale.`
        },
        {
          title: '2. Utilizarea Site-ului',
          content: `Prin utilizarea acestui site, vă angajați să:
- Furnizați informații corecte și actualizate
- Nu folosiți site-ul în scopuri ilegale sau frauduloase
- Nu încercați să accesați zone neautorizate ale site-ului
- Nu distribuiți conținut ilegal sau ofensator
- Respectați drepturile de proprietate intelectuală`
        },
        {
          title: '3. Comenzi și Prețuri',
          content: `Toate prețurile afișate pe site sunt în Lei (RON) și includ TVA.

Ne rezervăm dreptul de a:
- Modifica prețurile fără notificare prealabilă
- Refuza sau anula orice comandă din motive justificate
- Limita cantitățile disponibile pentru anumite produse

Confirmarea comenzii se face prin email. Contractul se consideră încheiat în momentul în care primiți confirmarea comenzii.`
        },
        {
          title: '4. Livrare',
          content: `Livrăm flori proaspete în zonele desemnate, în funcție de disponibilitate.

Detalii importante despre livrare:
- Livrare în aceeași zi pentru comenzile in functie de ora
- Costurile de livrare variază în funcție de zonă și sunt afișate la finalizarea comenzii
- Pentru evenimente speciale (nunți, botezuri), contactați-ne direct pentru programare
- Nu suntem responsabili pentru întârzieri cauzate de evenimente în afara controlului nostru`
        },
        {
          title: '5. Returnări și Rambursări',
          content: `Datorită naturii perisabile a produselor noastre (flori proaspete), nu acceptăm returnări standard.

Însă, dacă:
- Produsul livrat diferă semnificativ de cel comandat
- Florile sosesc deteriorate sau nu sunt proaspete
- Există o eroare din partea noastră

Vă rugăm să ne contactați în termen de 24 de ore de la livrare. Vom analiza fiecare caz și vom oferi o soluție potrivită (înlocuire sau rambursare).`
        },
        {
          title: '6. Proprietate Intelectuală',
          content: `Tot conținutul acestui site (text, imagini, logo-uri, design) este protejat de drepturi de autor și aparține Buchetul Simonei.

Este interzis:
- Copierea, reproducerea sau distribuirea conținutului fără acordul nostru scris
- Utilizarea logo-ului sau mărcii noastre fără permisiune
- Preluarea imaginilor produselor pentru uz comercial`
        },
        {
          title: '7. Limitarea Răspunderii',
          content: `În limita permisă de lege, nu suntem răspunzători pentru:
- Daune indirecte, accidentale sau consecutive
- Pierderi de profit sau date
- Întreruperi ale serviciului
- Erori sau omisiuni în conținutul site-ului

Răspunderea noastră maximă este limitată la valoarea produsului achiziționat.`
        },
        {
          title: '8. Protecția Datelor',
          content: `Ne angajăm să protejăm confidențialitatea datelor dumneavoastră personale conform GDPR și legislației în vigoare.

Pentru detalii complete despre cum colectăm, procesăm și protejăm datele dvs., consultați Politica de Confidențialitate și secțiunea GDPR.`
        },
        {
          title: '9. Modificări ale Termenilor',
          content: `Ne rezervăm dreptul de a modifica acești Termeni și Condiții în orice moment. Modificările vor fi publicate pe această pagină cu data actualizării.

Continuarea utilizării site-ului după modificări înseamnă acceptarea noilor termeni.`
        },
        {
          title: '10. Contact',
          content: `Pentru întrebări sau clarificări despre acești Termeni și Condiții, vă rugăm să ne contactați:

Email: simonabuzau2@gmail.com
Telefon: +40 769 141 250
Adresă: Str. Unirii 240, Tamaseni, Neamț, România`
        }
      ]
    },
    en: {
      title: 'Terms and Conditions',
      lastUpdated: 'Last updated: January 30, 2026',
      backHome: 'Back to home',
      sections: [
        {
          title: '1. General Information',
          content: `Welcome to Buchetul Simonei! By accessing and using this website, you agree to comply with these Terms and Conditions. Please read them carefully before using our services.

Buchetul Simonei is an online store specializing in the sale of fresh flowers, bouquets, and floral arrangements for various events and special occasions.`
        },
        {
          title: '2. Website Usage',
          content: `By using this website, you agree to:
- Provide accurate and up-to-date information
- Not use the site for illegal or fraudulent purposes
- Not attempt to access unauthorized areas of the site
- Not distribute illegal or offensive content
- Respect intellectual property rights`
        },
        {
          title: '3. Orders and Pricing',
          content: `All prices displayed on the site are in Lei (RON) and include VAT.

We reserve the right to:
- Modify prices without prior notice
- Refuse or cancel any order for justified reasons
- Limit quantities available for certain products

Order confirmation is sent via email. The contract is considered concluded when you receive order confirmation.`
        },
        {
          title: '4. Delivery',
          content: `We deliver fresh flowers in designated areas, subject to availability.

Important delivery details:
- Same-day delivery for orders in function of the time
- Delivery costs vary by area and are displayed at checkout
- For special events (weddings, baptisms), contact us directly for scheduling
- We are not responsible for delays caused by events beyond our control`
        },
        {
          title: '5. Returns and Refunds',
          content: `Due to the perishable nature of our products (fresh flowers), we do not accept standard returns.

However, if:
- The delivered product significantly differs from what was ordered
- Flowers arrive damaged or not fresh
- There is an error on our part

Please contact us within 24 hours of delivery. We will analyze each case and offer an appropriate solution (replacement or refund).`
        },
        {
          title: '6. Intellectual Property',
          content: `All content on this site (text, images, logos, design) is copyright protected and belongs to Buchetul Simonei.

It is prohibited to:
- Copy, reproduce or distribute content without our written consent
- Use our logo or brand without permission
- Take product images for commercial use`
        },
        {
          title: '7. Limitation of Liability',
          content: `To the extent permitted by law, we are not liable for:
- Indirect, incidental or consequential damages
- Loss of profit or data
- Service interruptions
- Errors or omissions in site content

Our maximum liability is limited to the value of the purchased product.`
        },
        {
          title: '8. Data Protection',
          content: `We are committed to protecting the confidentiality of your personal data in accordance with GDPR and current legislation.

For complete details on how we collect, process and protect your data, please refer to our Privacy Policy and GDPR section.`
        },
        {
          title: '9. Changes to Terms',
          content: `We reserve the right to modify these Terms and Conditions at any time. Changes will be posted on this page with the update date.

Continued use of the site after changes means acceptance of the new terms.`
        },
        {
          title: '10. Contact',
          content: `For questions or clarifications about these Terms and Conditions, please contact us:

Email: simonabuzau2@gmail.com
Phone: +40 769 141 250
Address: Str. Unirii 240, Tamaseni, Neamț, România`
        }
      ]
    }
  };

  const t = content[language as keyof typeof content] || content.ro;

  return (
    <main className="organic min-h-screen">
      {/* Header */}
      <div style={{ paddingTop: 'calc(64px + var(--space-6))', borderBottom: '1px solid var(--color-divider)' }}>
        <div className="max-w-4xl mx-auto" style={{ padding: 'var(--space-6) clamp(20px, 4vw, 48px)' }}>
          <Link
            href="/"
            className="btn btn-ghost"
            style={{ marginBottom: 'var(--space-4)', paddingInline: 0 }}
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={2.75} />
            {t.backHome}
          </Link>
          <h1 style={{ margin: '0 0 var(--space-2)', fontSize: 'clamp(30px, 3.6vw, 44px)' }}>
            {t.title}
          </h1>
          <p style={{ fontSize: 13.5, color: 'color-mix(in srgb, var(--color-text) 60%, transparent)', margin: 0 }}>
            {t.lastUpdated}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto" style={{ padding: 'var(--space-8) clamp(20px, 4vw, 48px)' }}>
        <div className="card elev-sm" style={{ padding: 'calc(var(--space-8) * 1.1)', display: 'flex', flexDirection: 'column', gap: 'var(--space-6)' }}>
          {t.sections.map((section, index) => (
            <section key={index} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' }}>
              <h2 style={{ margin: 0, fontSize: 22 }}>
                {section.title}
              </h2>
              <div style={{ color: 'color-mix(in srgb, var(--color-text) 82%, transparent)', whiteSpace: 'pre-line', lineHeight: 1.7 }}>
                {section.content}
              </div>
              {index < t.sections.length - 1 && (
                <div style={{ borderBottom: '1px solid var(--color-divider)', paddingTop: 'var(--space-2)' }}></div>
              )}
            </section>
          ))}
        </div>

        {/* Footer Links */}
        <div className="flex flex-wrap justify-center items-center" style={{ gap: 'var(--space-3)', marginTop: 'var(--space-8)', fontSize: 13.5 }}>
          <Link href="/politica-cookies" style={{ color: 'var(--color-accent)', fontWeight: 600 }}>
            Politica de Cookies
          </Link>
          <span style={{ color: 'color-mix(in srgb, var(--color-text) 40%, transparent)' }}>•</span>
          <Link href="/gdpr" style={{ color: 'var(--color-accent)', fontWeight: 600 }}>
            GDPR
          </Link>
          <span style={{ color: 'color-mix(in srgb, var(--color-text) 40%, transparent)' }}>•</span>
          <Link href="/contact" style={{ color: 'var(--color-accent)', fontWeight: 600 }}>
            Contact
          </Link>
        </div>
      </div>
    </main>
  );
}
